import React from "react";
import { styledH1 } from "./Title.module.scss";
import { ITitleProps } from "../TitleProps";

const Title: React.FC<ITitleProps> = (props) => {
  return <h1 className={styledH1}>{props.children}</h1>;
};

export default Title;
